const resources = {
    freeShipping: 'Free Shipping'
};

export default function getResource(label) {
    return resources[label];
}
